module.exports = __webpack_public_path__ + "static/sf-ui-bold-b9b6eb670e895a226590c847589b7b58.ttf";